import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import localization from '@/constant/localization';
import { items } from '@/mock-data/wallets';
import WalletListItem from '@/components/wallet-list-item';
import useUserWalletsVouchersStore from '@/store/user-wallets-store';

const OtherWallets = () => {
  const { unusableSegments, zeroBalanceSegments } = useUserWalletsVouchersStore()
  return (
    <Container className='pt- flex flex-col items-start p-4'>
      <Text semiBold className='text-xl text-grayLight-1000 dark:text-grayLight-0'>
        {localization.unUsableWallets}
      </Text>
      <Text className='text-md mb-6 mt-2 text-grayLight-600 dark:text-grayDark-300'>
        {localization.unUsableWalletsInStore}
      </Text>
      <Container className='mb-10 flex lg:max-h-[380px] w-full flex-col  gap-3 overflow-y-auto'>
        {unusableSegments?.length > 0 &&
          unusableSegments?.map((item, index) => (
            <WalletListItem
              key={index}
              data={item}
              unUsable
              disable={localization.deActiveInThisStore}
            />
          ))}
        {zeroBalanceSegments?.length > 0 &&
          zeroBalanceSegments?.map((item, index) => (
            <WalletListItem
              key={index}
              data={item}
              unUsable
              disable={localization.zeroBalance}
            />
          ))}
      </Container>
    </Container>
  );
}
export default OtherWallets